import { render, staticRenderFns } from "./Content_en.vue?vue&type=template&id=60ac7b06&scoped=true&"
import script from "./Content_en.vue?vue&type=script&lang=js&"
export * from "./Content_en.vue?vue&type=script&lang=js&"
import style0 from "./Content_en.vue?vue&type=style&index=0&id=60ac7b06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ac7b06",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
